export default {
      id: "common__geozone_corridor-usage",
      viewBox: "0 0 37 15",
      url: __webpack_public_path__ + "img/icons.svg#common__geozone_corridor",
      toString: function () {
        return this.url;
      }
    }